// extracted by mini-css-extract-plugin
export default {"root":"ClientsView_root__KTe48","wrapper":"ClientsView_wrapper__MLSWR"};